export const loanRepaymentsQuestions: Record<string, any> = {
  securedLoans: {
    labelKey: 'applicationForm.LOAN_REPAYMENTS.securedLoans.label',
    explanationKey: 'applicationForm.LOAN_REPAYMENTS.securedLoans.explanation',
    adornmentKey: 'common.monthly',
  },
  unsecuredLoans: {
    labelKey: 'applicationForm.LOAN_REPAYMENTS.unsecuredLoans.label',
    explanationKey: 'applicationForm.LOAN_REPAYMENTS.unsecuredLoans.explanation',
    adornmentKey: 'common.monthly',
  },
};
